import { useInjection } from 'inversify-react';
import { ReactElement } from 'react';
import { ICurrentWorkspaceStore } from '../../../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { UpdateWorkspaceTimeZoneMenuItem } from '../components/UpdateWorkspaceTimeZoneDropdownItem';
import { IUpdateWorkspaceTimeZoneBl } from '../UpdateWorkspaceTimeZone.bl';

export const UpdateWorkspaceTimeZoneMenuItemContainer = (): ReactElement => {
  const bl = useInjection(IUpdateWorkspaceTimeZoneBl.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const handleClick = (): void => {
    bl.showForm(currentWorkspaceStore.currentWorkspace.id, currentWorkspaceStore.currentWorkspace.timeZoneOffset);
  };

  return <UpdateWorkspaceTimeZoneMenuItem onClick={handleClick} />;
};
